<template>
    <div>
        <div id="root" class="component-dist" :key="entrypoint"></div>
    </div>
</template>
<script>
export default {
    props: {
        entrypoint: {
            type: String,
            required: true
        },

        component: {
            type: Object,
            required: true
        },

        dist: {
            type: Object,
            required: true
        }
    },

    computed: {
        code() {
            return this.dist.dist[`${this.entrypoint}.js`]
        }
    },

    async mounted() {
        try {
            console.log('=== ComponentDist Debug ===');
            console.log('Entrypoint:', this.entrypoint);
            console.log('Component:', this.component);
            console.log('Dist object:', this.dist);
            console.log('Code length:', this.code.length);
            console.log('Last 200 lines of code:');
            
            // Get last 200 lines
            const lines = this.code.split('\n');
            console.log(lines.join('\n'));
            console.log('=== End Debug ===');
            
            // Replace both "export default" and "export { X as default }" with a global variable assignment
            let modifiedCode = this.code
                // Handle: export { ClassName as default };
                .replace(/export\s*\{\s*(\w+)\s+as\s+default\s*\};?/g, 'let $tempComponent = $1;')
                // Handle: export default ClassName;
                .replace(/export\s+default\s+(\w+);?/g, 'let $tempComponent = $1;')
                // Handle: export default class ClassName { ... }
                .replace(/export\s+default\s+/g, 'let $tempComponent = ');

            // Add the customElements.define call without using template literals
            const elementName = this.entrypoint + '-component';
            modifiedCode = modifiedCode + '\ncustomElements.define("' + elementName + '", $tempComponent);';
            
            // Execute the modified code
            const script = document.createElement('script');
            script.textContent = modifiedCode;
            document.head.appendChild(script);

            // Append the custom element to the root div
            await this.$nextTick();
            const root = this.$el.querySelector('#root');
            const customElement = document.createElement(elementName);
            
            // Pass component data as a property
            customElement.component = this.component;
            
            root.appendChild(customElement);
        } catch (error) {
            console.error('Error loading component:', error);
            this.$bvToast.toast(`Failed to load component: ${error.message}`, {
                title: 'Component Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000
            });
        }
    },
}
</script>